//
//
//
//
//
//
import store from '../../store';
export default {
  store: store,
  name: 'App'
};